module.exports = "https://trybtryb-legacy.web.app/img/delete.de02a639.svg";